import { type PaymentMethodResult as StripePaymentMethodResult } from '@stripe/stripe-js'
import { PaymentMethodProviderType, StripeCardFunding, TPCardFunding, type TPCardResult } from '@/view-models/payment'
import { FALLBACK_TIMEZONE, PAYMENT_CARD_EXPIRY_DATE_COUNT } from '@/constants/payment'

export function usePaymentCardInfo() {
  const { $store: store, $dayjs: dayjs } = useNuxtApp()
  const storeTimezone = computed(() => store.getters['booking/timeZone'])
  const bookingStartDateTime = computed<string>(() => store.state.booking.bookingStartDateTime)

  function checkIsInvalidCard(providerType: PaymentMethodProviderType, sdkPaymentData: any): boolean {
    try {
      // Perform card validation checks
      if (providerType === PaymentMethodProviderType.Stripe) {
        const data = sdkPaymentData as StripePaymentMethodResult
        return data?.paymentMethod?.card?.funding === StripeCardFunding.DEBIT || data?.paymentMethod?.card?.funding === StripeCardFunding.UNKNOWN
      }
      if (providerType === PaymentMethodProviderType.TapPay) {
        const data = sdkPaymentData as TPCardResult
        return data?.card?.funding === TPCardFunding.DEBIT || data?.card?.funding === TPCardFunding.UNKNOWN
      }

      return false
    } catch (error) {
      console.error('card type check error:', error)
      return false
    }
  }

  function checkCardExpired(data: { expirationMonth?: number; expirationYear?: number }): boolean {
    try {
      const { expirationMonth, expirationYear } = data || {}
      const bookingTime = bookingStartDateTime.value
      const timezone = storeTimezone.value || FALLBACK_TIMEZONE

      if (!expirationMonth || !expirationYear || !bookingTime) {
        return false
      }

      // 建立該月的最後一天
      const cardExpiryDate = dayjs.tz(`${expirationYear}-${expirationMonth.toString().padStart(2, '0')}-01`, timezone).endOf('month')

      // 建立 bookingTime 的 dayjs 物件
      const bookingDate = dayjs.tz(bookingTime, timezone)

      // 檢查卡片到期日是否早於 bookingTime + options.days 天
      const expiryThresholdDate = bookingDate.add(PAYMENT_CARD_EXPIRY_DATE_COUNT, 'day')
      return cardExpiryDate.isBefore(expiryThresholdDate)
    } catch (error) {
      console.error('card expiration check error:', error)
      return false
    }
  }

  return {
    checkIsInvalidCard,
    checkCardExpired,
  }
}
